<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-key`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.2388 3.50732C13.7194 3.50784 15.7307 5.51884 15.731 7.99951C15.7309 10.4804 13.7195 12.4922 11.2388 12.4927C8.98395 12.4927 7.1174 10.8308 6.79541 8.66553H0.935059C0.567909 8.66545 0.270105 8.36764 0.27002 8.00049C0.27002 7.63327 0.567856 7.33553 0.935059 7.33545H2.51318V4.8335C2.51329 4.46636 2.81108 4.16854 3.17822 4.16846C3.54536 4.16854 3.84316 4.46637 3.84326 4.8335V7.33545H6.79443C7.11566 5.16933 8.98334 3.50732 11.2388 3.50732ZM11.2388 4.8374C9.49226 4.8374 8.07595 6.25306 8.07568 7.99951C8.07574 9.74614 9.49213 11.1626 11.2388 11.1626C12.985 11.1621 14.4008 9.74582 14.4009 7.99951C14.4006 6.25338 12.9848 4.83792 11.2388 4.8374Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineKey',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
